<div id="academy-courses" class="page-layout simple">

    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text">
            <!-- <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">school</mat-icon> -->
            <h1 >
              {{'WIZARD.LANDING_REQUERIMIENTOSV3.TITULO' | translate}}

            </h1>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" >
                <ng-container *ngIf="!pulse3Navigation">
                  <ng-container *ngFor="let producto of aniosPulsecheck">
                    <ng-container *ngIf="producto.fecha == anioseleccionado ">
                      <ng-container *ngFor="let productoPulsos of producto.datos">

                        <div  class="course" fxFlex="100" fxFlex.gt-sm="33" >
                            <div class="cursoCard" fxFlex="100">
                              <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                                <div class="header primary " fxLayout="row" fxLayoutAlign="center center">
                                  <div class="category" fxFlex>{{'WIZARD.LANDING.PRODUCTO.PULSE.PULSOS' | translate}}</div>
                                  <div * class="length" fxLayout="row" fxLayoutAlign="end center">
                                    <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                                  </div>
                                </div>

                                <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                  <div class="h1">{{'WIZARD.LANDING.PRODUCTO.PULSE.PRODU' | translate}} {{productoPulsos.numero}} </div>
                                  <!-- <div class="h1"> {{productoPulsos.fechaLanzamiento |date:"fullDate":'':idiomaActual}}</div> -->
                                </div>

                                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                                    <button mat-button class="accent rndBt" fxFlex="100"
                                    (click)="navigateTo('/requirements-detail',productoPulsos.idPulseCheck);">{{'WIZARD.LANDING.PRODUCTO.PULSE.ENTRAR' | translate}}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                </ng-container>

                <ng-container *ngIf="pulse3Navigation">
                  <ng-container *ngFor="let producto of aniosPulsecheck">
                    <ng-container *ngIf="producto.fecha == anioseleccionado ">
                      <ng-container *ngFor="let productoPulsos of producto.datos">
                        <div  class="course" fxFlex="100" fxFlex.gt-sm="40">
                            <div class="cursoCard" fxFlex="100" [ngClass]="producto.category"  [@animate]="{value:'*',params:{y:'100%'}}">
                              <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                                <div class="header primary " fxLayout="row" fxLayoutAlign="center center">
                                  <div class="category" fxFlex *ngIf="!productoFocus">{{'WIZARD.LANDING.PRODUCTO.PULSE.PULSOS' | translate}}</div>
                                  <div class="category" fxFlex *ngIf="productoFocus">{{'LANDINFOCUS.ENCUESTAS.TITULO' | translate}}</div>
                                  <div * class="length" fxLayout="row" fxLayoutAlign="end center">
                                    <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                                  </div>
                                </div>

                                <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                  <div class="h1" *ngIf="!productoFocus">{{'WIZARD.LANDING.PRODUCTO.PULSE.PRODU' | translate}} {{productoPulsos.numPulse+1}} </div>
                                  <div class="h1" *ngIf="productoFocus">{{productoPulsos.nameSurvey}}</div>
                                  <!-- <div class="h1"> {{productoPulsos.fechaLanzamiento |date:"fullDate":'':idiomaActual}}</div> -->
                                </div>
                                <div  fxLayout="column" fxLayoutAlign="center center">
                                    <button mat-button class="accent rndBt" color="accent" fxFlex="100"
                                    (click)="navigateTo(urlReqtec,productoPulsos.idCertificar,productoPulsos.idProducto,productoPulsos.survey_subdomain,productoPulsos.ipPublic);">{{'WIZARD.LANDING.PRODUCTO.PULSE.ENTRAR' | translate}}</button>
                                    <br>
                                    <button *ngIf="linkCertificar3" mat-button class="accent rndBt" fxFlex="100" matTooltip="{{productoPulsos.urlRT}}"
                                    (click)="copyMessage(productoPulsos.urlRT)" style="height: 50px">{{'WIZARD.LANDING_REQUERIMIENTOSV3.EXTERNAL_PORTAL' | translate}}</button>
                                </div>


                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                </ng-container>

            </div>
            <!-- / CONTENT -->

        </div>
